import { genericGet } from "../../services/api.service";
import { EntityConfig } from "../../types/EntityConfig";


export const OcorrenciasTableConfig: EntityConfig = [

  {
    id: 'id',
    label: 'Id',
    type: "id",
    nonEditable: true
  }, {
    id: 'posto',
    label: 'Posto',
    type: 'enum',
    filterable: true,
    options: {
      getter: () => genericGet('/ocorrencias/postos/options'),

    }
  }, {
    id: 'urgencia',
    label: 'Urgência',
    type: 'enum',
    filterable: true,
    options: {
      getter: () => genericGet('/ocorrencias/urgencias/options'),

    }
  }, {
    id: 'descricao',
    label: 'Descrição',
    type: 'text',
    options: {
      isMultiLine: true
    }
  }, {
    id: 'recipientes',
    label: 'Destinatários',
    type: 'multi-select',
    routable: true,
    options: {
      name: 'Destinatários',
      route: 'utilizadores',
      value: 'id',
      label: 'name',
      getter: () => genericGet('/findByFilter/utilizadores'),
    },
  },
  {
    id: 'obra',
    label: 'Obra',
    type: 'select',
    routable: true,
    options: {
      name: 'Obra',
      route: 'obras',
      value: 'id',
      label: 'number',
      getter: () => genericGet('/findByFilter/obras'),
    }
  }, {
    id: 'estado',
    label: 'Estado',
    type: 'enum',
    filterable: true,
    options: {
      getter: () => genericGet('/ocorrencias/estados/options'),

    }
  },
  {
    id: 'dataEntrega',
    label: 'Data de entrega',
    type: "date"
  },
  {
    id: 'createdBy',
    label: 'Criada por',
    type: 'select',
    nonEditable: true,
    options: {
      label: 'name'
    }
  },
  {
    id: 'created_at',
    label: 'Criada em',
    type: 'date',
    nonEditable: true
  }

]